module.exports = __webpack_public_path__ + "img/audio-equip.44397103.jpg";